;(function () {
  if (customElements.get('related-products-carousel')) return

  class RelatedProductsCarousel extends HTMLElement {
    connectedCallback() {
      this.sliderEl = this.querySelector('.related-slider')
      this.blockCount = Number(this.dataset.blockCount || 0)
      this.slider = null

      if (!this.sliderEl || this.blockCount <= 1) return

      this.boot()
      this.bindDesignMode()
    }

    disconnectedCallback() {
      this.teardown()
    }

    mount() {
      if (!window.AeroSlider || this.slider) return
      this.slider = window.AeroSlider.createSlider(this.sliderEl, {
        loop: true,
        draggable: true,
        alignment: 'center',
      })
    }

    boot() {
      if (window.AeroSlider) {
        this.mount()
      } else {
        window.addEventListener('load', () => this.mount(), { once: true })
      }
    }

    teardown() {
      if (this.slider) {
        this.slider.destroy()
        this.slider = null
      }
    }

    bindDesignMode() {
      if (!window.Shopify?.designMode) return

      const reinit = () => {
        this.teardown()
        this.boot()
      }

      ;['shopify:section:load', 'shopify:section:select'].forEach((evt) => {
        document.addEventListener(evt, (e) => {
          if (!e?.detail || !this.isConnected) return
          const container = document.getElementById('shopify-section-' + e.detail.sectionId)
          if (container?.contains(this)) reinit()
        })
      })

      ;['shopify:section:unload', 'shopify:section:deselect'].forEach((evt) => {
        document.addEventListener(evt, (e) => {
          if (!e?.detail || !this.isConnected) return
          const container = document.getElementById('shopify-section-' + e.detail.sectionId)
          if (container?.contains(this)) this.teardown()
        })
      })
    }
  }

  customElements.define('related-products-carousel', RelatedProductsCarousel)
})()
